import logContext from "@shared/v2/lib/logContext";

import { IS_SERVER, VISIT_ID_COOKIE } from "@shared/constants";

const REQUEST_ID_HEX_LENGTH = 8;

function createBrowserRequestId() {
  let id = "";

  while (id.length < REQUEST_ID_HEX_LENGTH) {
    id += Math.floor(Math.random() * 16).toString(16);
  }

  return id;
}

export function getVisitIdFromCookie() {
  if (IS_SERVER) {
    return null;
  }

  const match = document.cookie.match(
    new RegExp(`(?:^|; )${VISIT_ID_COOKIE.replace(".", "\\.")}=([^;]*)`)
  );

  if (!match) {
    return null;
  }

  return decodeURIComponent(match[1]);
}

/**
 * Puts the visit id into the browser log context once per page load, so
 * client-side 'debug' lines carry the same visitId as the server ones.
 */
export function initBrowserLogContext() {
  if (IS_SERVER) {
    return;
  }

  logContext.set({ visitId: getVisitIdFromCookie() });
}

/**
 * The visit id to send on an outgoing call. On the server it comes from the
 * request context; in the browser it is read from the cookie, because the
 * cookie is scoped to the frontend host and does not reach deal-api by itself.
 */
export function getOutgoingVisitId() {
  if (!IS_SERVER) {
    return getVisitIdFromCookie();
  }

  const context = logContext.get();

  if (!context) {
    return null;
  }

  return context.visitId || null;
}

/**
 * The request id to send on an outgoing call. On the server it is the id of the
 * request being served, so the whole chain shares one value. In the browser
 * each call gets its own - there is no inbound request to inherit from.
 */
export function getOutgoingRequestId() {
  if (!IS_SERVER) {
    return createBrowserRequestId();
  }

  const context = logContext.get();

  if (!context) {
    return null;
  }

  return context.requestId || null;
}
